const gustavoToJSON = (Datos) => {

    /**
     * Función auxiliar que toma un array de objetos {Nombre, Valor} y
     * lo convierte en un objeto { Nombre1: Valor1, Nombre2: Valor2, ... }.
     */
    const parseListaClaveValor = (lista) => {
        const resultado = {};
        lista.forEach(item => {
            if (item && item.Nombre !== undefined && item.Valor !== undefined) {
                resultado[item.Nombre] = item.Valor;
            }
        });
        return resultado;
    };

    // Caso 1: array de arrays (cada sub-array contiene objetos { Nombre, Valor })
    //   => devolvemos un array de objetos
    // Ejemplo: Datos = [ [ { Nombre: 'idmodulo', Valor: '1' }, ... ], [ ... ] ]
    if (Array.isArray(Datos[0])) {
        // Entonces mapeamos cada sub-array
        return Datos.map(subArray => parseListaClaveValor(subArray));
    }

    // Caso 2: array de objetos { Nombre, Valor } en un solo bloque
    //   => lo convertimos en un único objeto y lo envolvemos en un array
    // Ejemplo: Datos = [ { Nombre: 'cedularuc', Valor: '1313347765' }, ... ]
    if (Datos.length > 0 && Datos[0].Nombre !== undefined && Datos[0].Valor !== undefined) {
        return parseListaClaveValor(Datos);
    }

    // Si no coincide con ninguno de los casos anteriores, retornamos arreglo vacío
    return [];
}
export default gustavoToJSON